import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CompanyFeaturesQuery, CompanyFeaturesQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CompanyFeaturesQuery)
@Wrapper(CompanyFeaturesQueryHandlerBase)
export class CompanyFeaturesQueryHandler {
    public constructor(
        http: Http
    ) { }
}
